import gql from 'graphql-tag';

export const GET_PRODUCTO_BY_ID = gql(`
    query producto($id: Long, $idioma: String) {
        producto(id: $id) {
            id
            codigoProducto
            fechaAlta
            literalProducto(idioma: $idioma){
                clave
                valor
            }
        }
    }
`);

export const GET_PRODUCTOS_BY_IDLEGAL_CLIENTE = gql(`
    query productos ($id: String, $idioma: String) {
        productos(idLegal: $id) {
            idContrato
            id
            codigoProducto
            fechaAlta
            literalProducto(idioma: $idioma){
                clave
                valor
            }
            literalTipoServicio(idioma: $idioma){
                clave
                valor
            }
            promociones {
                nombre
                literalTipoPromocion(idioma: $idioma){
                    clave
                    valor
                }
                contadorUsos
                numeroUsos
                fechaAlta
            }
            contrato {
                tipo
                fechaInicio
                fechaFin
            }
        }
    }
`);

export const GET_PRODUCTOS_BY_IDLEGAL_CLIENTE_ICIRED = gql(`
    query productosIcired ($id: String, $idioma: String) {
        productosIcired(idLegal: $id) {
            idContrato
            id
            codigoProducto
            fechaAlta
            literalProducto(idioma: $idioma){
                clave
                valor
            }
            literalTipoServicio(idioma: $idioma){
                clave
                valor
            }
            promociones {
                nombre
                literalTipoPromocion(idioma: $idioma){
                    clave
                    valor
                }
                contadorUsos
                numeroUsos
                fechaAlta
            }
            contrato {
                fechaInicio
                fechaFin
                tipo
                iban
                excesos
                limiteOperacionPPFF
                limiteOperacionPPJJ
                periodoExpiracionPPJJ
                periodoExpiracionPPFF
            }
        }
    }
`);

export const GET_PRODUCTOS_BY_IDLEGAL_CLIENTE_AND_TIPO_ICIRED = gql(`
    query productosIciredPorTipo ($id: String, $tipo: String, $idioma: String) {
        productosIciredPorTipo(idLegal: $id, tipo: $tipo) {
            idContrato
            id
            codigoProducto
            fechaAlta
            tipoProducto{
                tipo
                codigo
                nombre
            }
            combinado {
                id
                nombre
                numeroUsos
                contadorUsos
                fechaAlta
                literalTipoCombinado(idioma: $idioma){
                    clave
                    valor
                }
            }
            literalProducto(idioma: $idioma){
                clave
                valor
            }
            literalTipoServicio(idioma: $idioma){
                clave
                valor
            }
            promociones {
                id
                nombre
                literalTipoPromocion(idioma: $idioma){
                    clave
                    valor
                }
                contadorUsos
                numeroUsos
                fechaAlta
            }
            contrato {
                fechaInicio
                fechaFin
                tipo
                iban
                excesos
                estado
                limiteOperacionPPFF
                limiteOperacionPPJJ
                periodoExpiracionPPJJ
                periodoExpiracionPPFF
            }
        }
    }
`);

export const GET_PRODUCTOS_BY_ID_CONTRATO = gql(`
    query productos ($id: Long, $idioma: String) {
        productos(idContrato: $id) {
            id
            codigoProducto
            fechaAlta
            literalProducto(idioma: $idioma){
                clave
                valor
            }
        }
    }
`);

export const ALTA_PRODUCTO = gql(`
mutation altaProducto ($altaProductoRequest: AltaProductoRequestInput) {
	altaProducto(altaProductoRequest: $altaProductoRequest) {
        id
	    codigoProducto
        fechaAlta    
	}
}
`);

export const MODIFICAR_PRODUCTO = gql(`
    mutation modificarProducto ($productoRequest: ModificarProductoRequestInput) {
        modificarProducto(modificarProductoRequest: $productoRequest) {
            id
            codigoProducto
            fechaAlta 
        }
    }
`);

export const BORRAR_PRODUCTO = gql(`
mutation borrarProducto ($id: Long) {
    borrarProducto(id: $id) {
        id
        codigoProducto
        fechaAlta 
    }
}
`);

export const LISTADO_PRODUCTOS = gql(`
query listadoProductos ($idioma: String) {
    listadoProductos(idioma: $idioma) {
        clave
        valor
    }
}
`);
